export default {
  dataIterator: {
    rowsPerPageText: 'ردیف در صفحه:',
    rowsPerPageAll: 'همه',
    pageText: '{0} تا {1} از {2}',
    noResultsText: 'نتیجه‌ای یافت نشد',
    nextPage: 'صفحه بعد',
    prevPage: 'صفحه قبل'
  },
  dataTable: {
    rowsPerPageText: 'ردیف در صفحه:'
  },
  noDataText: 'اطلاعاتی یافت نشد',
  carousel: {
    prev: 'تصویر قبلی',
    next: 'بعدی بصری'
  }
}
